// src/aws-config.js
import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      region: "us-east-2",
      userPoolId: "us-east-2_O6sOJ3wEX",
      userPoolClientId: "757n1fea7vqt1qfko0nm2m7j9a",
      mandatorySignIn: true,
      loginWith: {
        email: true,
        username: false
      }
    }
  }
});
